import { mergeSx } from "#hooks/mergeSx";
import { Paper, Tooltip, type PaperProps, Typography } from "@mui/material";
import React, { Fragment } from "react";
import { isValidElement } from "react";

export interface TextDisplayWidgetProps extends PaperProps {
  label?: string;
  size?: "small" | "large";
  helpText?: string;
}

export const TextDisplayWidget: React.FC<
  React.PropsWithChildren<TextDisplayWidgetProps>
> = ({ sx, label, size = "small", helpText, children, ...rest }) => {
  const card = (
    <Paper
      tabIndex={helpText ? 0 : undefined}
      sx={mergeSx(
        {
          p: size === "large" ? 2 : 1,
          display: "flex",
          flexDirection: size === "large" ? "row" : "column",
          justifyContent: "space-between",
        },
        sx
      )}
      {...rest}
    >
      {label && (
        <Typography
          variant={size === "large" ? "h4" : "body2"}
          color={size === "large" ? "default" : "text.secondary"}
          sx={
            size === "large"
              ? {
                  textAlign: "left",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }
              : {
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }
          }
        >
          {label}
        </Typography>
      )}
      {(Array.isArray(children) ? children : [children]).map((x, index) =>
        isValidElement(x) ? (
          <Fragment key={String(x) + index}>{x}</Fragment>
        ) : (
          <Typography
            variant="h4"
            sx={{
              textAlign: size === "large" ? "right" : "center",
              textOverflow: "ellipsis",
              overflow: "hidden",
              pb: 0.2,
            }}
            key={String(x) + index}
          >
            {x}
          </Typography>
        )
      )}
    </Paper>
  );
  return helpText ? (
    <Tooltip
      title={helpText}
      enterDelay={2500}
      enterNextDelay={2500}
      describeChild
    >
      {card}
    </Tooltip>
  ) : (
    card
  );
};
